<div id="OverrideModal" class="overrides-wrapper">
  <div class="overrides-container sized large">
    <div class="form-title-container">
      <div class="form-title-back-button" (click)="close.emit()">
        <div class="form-title-back-button-image"></div>
        <div class="form-title-back-button-line"></div>
      </div>
      <span class="title">IDENTITY OVERRIDES</span>
    </div>
    <div class="subtitle">Manage the Service Config Identity Overrides</div>
    @if (overrides.length > 0) {
      <div class="darkened overrides-label">Current Overrides</div>
      <table id="OverrideList" class="overrides-table">
        <colgroup>
          <col />
          <col />
          <col class="overrides-table__col-remove" />
        </colgroup>
        <thead>
          <tr>
            <th scope="col">Service</th>
            <th scope="col">Configuration</th>
            <th scope="col" class="overrides-table__th-remove" aria-label="Remove"></th>
          </tr>
        </thead>
        <tbody>
          @for (override of overrides; track override) {
            <tr>
              <td
                [matTooltip]="override.service.name"
                matTooltipShowDelay="300"
                >
                {{override.service.name}}
              </td>
              <td
                [matTooltip]="override.config.name"
                matTooltipShowDelay="300"
                >
                {{override.config.name}}
              </td>
              <td class="overrides-table__cell-remove">
                <button
                  type="button"
                  class="overrides-table__remove-btn"
                  (click)="removeOverride(override)"
                  [attr.aria-label]="'Remove override'"
                  >
                  <span class="remove icon-minus" aria-hidden="true"></span>
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
    <div class="darkened">ADD OVERRIDE CONFIG</div>
    <div class="grid split override-list-container">
      <div>
        <label for="ServiceList">Service</label>
        <lib-filter-select
          #servicesList
          id="ServiceList"
          [options]="services"
          [(ngModel)]="selectedServiceId"
          placeholder="Select a service"
          optionValue="id"
          optionLabel="name"
          [openOnFocus]="true"
          (filterChange)="filterServicesDebounced($event)"
        ></lib-filter-select>
      </div>
      <div>
        <label for="ConfigList">Configuration</label>
        <lib-filter-select
          #configList
          id="ConfigList"
          [options]="configs"
          [(ngModel)]="selectedConfigId"
          placeholder="Select a config"
          optionValue="id"
          optionLabel="name"
          [openOnFocus]="true"
          (filterChange)="filterConfigsDebounced($event)"
        ></lib-filter-select>
      </div>
    </div>
    <div class="buttons">
      <div
        id="AssociateButton"
        class="button confirm"
        [ngClass]="{disabled: disableAddButton}"
        (click)="addOverride()"
        >
        Add
      </div>
    </div>
  </div>
</div>